import React, {useEffect, useState} from 'react';
import {SectionsProps} from "../../../../../models";
import {Formik} from "formik";
import {BusinessFormOtherInformationValidation} from "../AddBusinessValidation";
import {Button, TextAreaField} from "../../../../../components";

export const Expectations: React.FC<SectionsProps> = ({
                                                          changeStep,
                                                          setNewBusinessInfo,
                                                          newBusinessInfo,
                                                          setSectionName
                                                      }) => {
    useEffect(() => {
        setSectionName('Expectation of the SBAJ')
    }, [setSectionName]);
    const [initialValues] = useState({
        expectation_of_sbaj: newBusinessInfo?.expectation_of_sbaj
    });


    const onSubmit = async (values: any, {setSubmitting}: any) => {
        setNewBusinessInfo && setNewBusinessInfo((prevInfo) => ({
            ...prevInfo,
            expectation_of_sbaj: values.expectation_of_sbaj
        }))

        changeStep && changeStep("next")
        setSubmitting(false);
    }
    return (
        <div className={'add-business-section'}>
            <p className={'info'}><span>Note:</span> Lorem Ipsum is simply dummy text of the
                printing and typesetting industry. </p>
            <Formik
                validateOnMount={false}
                validateOnChange={true}
                initialValues={initialValues}
                validationSchema={BusinessFormOtherInformationValidation}
                onSubmit={onSubmit}
            >
                {({handleSubmit, handleChange, values, handleBlur, errors, touched}) => (
                    <form onSubmit={handleSubmit}>
                        <div className={'add-business-section_input'}>
                            <div>
                                <span
                                    className={'add-business-section_heading'}>What are your expectations of the SBAJ?</span>
                                <TextAreaField
                                    id={"expectation_of_sbaj"}
                                    classname="signup__input"
                                    placeholder={"Expectations of SBAJ"}
                                    name="expectation_of_sbaj"
                                    onblur={handleBlur}
                                    error={errors.expectation_of_sbaj && touched.expectation_of_sbaj}
                                    onchange={handleChange}
                                    message={errors.expectation_of_sbaj && touched.expectation_of_sbaj && errors.expectation_of_sbaj}
                                    inputValue={values.expectation_of_sbaj}
                                    // label={'Expectations of SBAJ'}

                                />
                            </div>
                        </div>
                        <div className={'add-business-section_cta'}>

                            <Button type={"secondary"} onclick={() => changeStep && changeStep("prev")} text={"Prev"}/>
                            <Button type={"primary"} isSubmit={true} text={"Next"}/>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default Expectations;
